import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      borderRadius: 6,
      background: "white",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      overflow: "hidden",
      marginTop: "1.6rem",
      marginBottom: "2.4rem",
      width: "100%"
    },
    wrapper: {
      display: "flex",
      justifyContent: "space-between"
    },
    "& .custom-select": {
      overflowY: "auto"
    },
    required: {
      color: "#FF2600",
      "& :after": {
        content: "*"
      }
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5,
      position: "absolute",
      fontSize: 12
    },
    flex: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    icon: {
      marginRight: "1.1rem"
    },
    checkbox: {
      backgroundColor: "transparent",
      boxShadow: "none !important"
    },
    radioGroup: {
      flexDirection: "row"
    },
    selectField: {
      height: "36px",
      "& .MuiSelect-root": {
        padding: "0.8rem 1.2rem",
        color: theme.palette.grey[800]
      }
    },
    disabled: {
      border: "1px solid #999999",
      backgroundColor: "#cccccc",
      color: "#666666"
    },
    datePicker: {
      background: theme.palette.background.default,
      padding: 12
    },
    wrapDatePickerError: {
      display: "flex"
    },
    empty: {
      width: 30
    },
    datePickerError: {
      flex: 1
    },
    emptyBox: {
      position: "absolute"
    },
    suggestionBox: {
      position: "absolute",
      height: 166
    },
    shipToBtn: {
      padding: "5px 14px"
    },
    wrapShipToBtn: {
      display: "flex",
      justifyContent: "space-between",
      cursor: "pointer"
    },
    iconEditShipTo: {
      paddingBottom: 3
    },
    listItemClass: {
      "& .MuiTypography-body1": {
        fontSize: 14
      },
      fontSize: 14
    }
  }),
  { name: "FormField" }
);

export default useStyles;
